import styled from 'styled-components'

export const ProductList = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  max-width: 1068px;
  gap: 8px;
  padding: 0 8px;

  @media (min-width: 375px) {
    flex-direction: row;
    flex-wrap: wrap;
  }

  @media (min-width: 600px) {
    margin-top: 24px;
    padding: unset;
    gap: 4px;
  }
`
